// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1dFaj","label":"Labeled_label__3WJLV","divider":"Labeled_divider__3qrAH"};